import { ref, isRef, Ref } from 'vue'
import { useCommand } from '@cqrs/vue-composables-cqrs'
import * as c from './commands-core'

export function useActivatePipelineCommandV1(
	id?: string | Ref<string> | (() => string), 
	organizationUnitId?: string | Ref<string> | (() => string), 
	updatedBy?: string | Ref<string> | (() => string), 
) 
{
	const _id = isRef<string>(id) ? id : ref<string>((typeof id === 'function') ? id() : id)
	const _organizationUnitId = isRef<string>(organizationUnitId) ? organizationUnitId : ref<string>((typeof organizationUnitId === 'function') ? organizationUnitId() : organizationUnitId)
	const _updatedBy = isRef<string>(updatedBy) ? updatedBy : ref<string>((typeof updatedBy === 'function') ? updatedBy() : updatedBy)

	const result = {
		id: _id,
		organizationUnitId: _organizationUnitId,
		updatedBy: _updatedBy,

		...useCommand(() => {
			if (typeof id === 'function') { _id.value = id() }
			if (typeof organizationUnitId === 'function') { _organizationUnitId.value = organizationUnitId() }
			if (typeof updatedBy === 'function') { _updatedBy.value = updatedBy() }

			return new c.ActivatePipelineCommandV1(_id.value, _organizationUnitId.value, _updatedBy.value)
		})
	}

	return {
		...result,
		authorizedActivatePipelineCommandV1: result.authorized,
		activatePipelineCommandV1: result.command,
		completedActivatePipelineCommandV1: result.completed,
		errorActivatePipelineCommandV1: result.error,
		invokeActivatePipelineCommandV1: result.invoke,
		invokingActivatePipelineCommandV1: result.invoking,
		succeedActivatePipelineCommandV1: result.succeed,
		validationErrorsActivatePipelineCommandV1: result.validationErrors,
		onSucceedActivatePipelineCommandV1: result.onSucceed,
	}
}

export function useAddPropertyNameMappingCommandV1(
	id?: string | Ref<string> | (() => string), 
	organizationUnitId?: string | Ref<string> | (() => string), 
	updatedBy?: string | Ref<string> | (() => string), 
	nameForConnector?: string | Ref<string> | (() => string), 
	nameForDataset?: string | Ref<string> | (() => string), 
) 
{
	const _id = isRef<string>(id) ? id : ref<string>((typeof id === 'function') ? id() : id)
	const _organizationUnitId = isRef<string>(organizationUnitId) ? organizationUnitId : ref<string>((typeof organizationUnitId === 'function') ? organizationUnitId() : organizationUnitId)
	const _updatedBy = isRef<string>(updatedBy) ? updatedBy : ref<string>((typeof updatedBy === 'function') ? updatedBy() : updatedBy)
	const _nameForConnector = isRef<string>(nameForConnector) ? nameForConnector : ref<string>((typeof nameForConnector === 'function') ? nameForConnector() : nameForConnector)
	const _nameForDataset = isRef<string>(nameForDataset) ? nameForDataset : ref<string>((typeof nameForDataset === 'function') ? nameForDataset() : nameForDataset)

	const result = {
		id: _id,
		organizationUnitId: _organizationUnitId,
		updatedBy: _updatedBy,
		nameForConnector: _nameForConnector,
		nameForDataset: _nameForDataset,

		...useCommand(() => {
			if (typeof id === 'function') { _id.value = id() }
			if (typeof organizationUnitId === 'function') { _organizationUnitId.value = organizationUnitId() }
			if (typeof updatedBy === 'function') { _updatedBy.value = updatedBy() }
			if (typeof nameForConnector === 'function') { _nameForConnector.value = nameForConnector() }
			if (typeof nameForDataset === 'function') { _nameForDataset.value = nameForDataset() }

			return new c.AddPropertyNameMappingCommandV1(_id.value, _organizationUnitId.value, _updatedBy.value, _nameForConnector.value, _nameForDataset.value)
		})
	}

	return {
		...result,
		authorizedAddPropertyNameMappingCommandV1: result.authorized,
		addPropertyNameMappingCommandV1: result.command,
		completedAddPropertyNameMappingCommandV1: result.completed,
		errorAddPropertyNameMappingCommandV1: result.error,
		invokeAddPropertyNameMappingCommandV1: result.invoke,
		invokingAddPropertyNameMappingCommandV1: result.invoking,
		succeedAddPropertyNameMappingCommandV1: result.succeed,
		validationErrorsAddPropertyNameMappingCommandV1: result.validationErrors,
		onSucceedAddPropertyNameMappingCommandV1: result.onSucceed,
	}
}

export function useAttachConnectorCommandV1(
	id?: string | Ref<string> | (() => string), 
	organizationUnitId?: string | Ref<string> | (() => string), 
	updatedBy?: string | Ref<string> | (() => string), 
	connectorId?: string | Ref<string> | (() => string), 
) 
{
	const _id = isRef<string>(id) ? id : ref<string>((typeof id === 'function') ? id() : id)
	const _organizationUnitId = isRef<string>(organizationUnitId) ? organizationUnitId : ref<string>((typeof organizationUnitId === 'function') ? organizationUnitId() : organizationUnitId)
	const _updatedBy = isRef<string>(updatedBy) ? updatedBy : ref<string>((typeof updatedBy === 'function') ? updatedBy() : updatedBy)
	const _connectorId = isRef<string>(connectorId) ? connectorId : ref<string>((typeof connectorId === 'function') ? connectorId() : connectorId)

	const result = {
		id: _id,
		organizationUnitId: _organizationUnitId,
		updatedBy: _updatedBy,
		connectorId: _connectorId,

		...useCommand(() => {
			if (typeof id === 'function') { _id.value = id() }
			if (typeof organizationUnitId === 'function') { _organizationUnitId.value = organizationUnitId() }
			if (typeof updatedBy === 'function') { _updatedBy.value = updatedBy() }
			if (typeof connectorId === 'function') { _connectorId.value = connectorId() }

			return new c.AttachConnectorCommandV1(_id.value, _organizationUnitId.value, _updatedBy.value, _connectorId.value)
		})
	}

	return {
		...result,
		authorizedAttachConnectorCommandV1: result.authorized,
		attachConnectorCommandV1: result.command,
		completedAttachConnectorCommandV1: result.completed,
		errorAttachConnectorCommandV1: result.error,
		invokeAttachConnectorCommandV1: result.invoke,
		invokingAttachConnectorCommandV1: result.invoking,
		succeedAttachConnectorCommandV1: result.succeed,
		validationErrorsAttachConnectorCommandV1: result.validationErrors,
		onSucceedAttachConnectorCommandV1: result.onSucceed,
	}
}

export function useAttachDatasetCommandV1(
	id?: string | Ref<string> | (() => string), 
	organizationUnitId?: string | Ref<string> | (() => string), 
	updatedBy?: string | Ref<string> | (() => string), 
	datasetId?: string | Ref<string> | (() => string), 
) 
{
	const _id = isRef<string>(id) ? id : ref<string>((typeof id === 'function') ? id() : id)
	const _organizationUnitId = isRef<string>(organizationUnitId) ? organizationUnitId : ref<string>((typeof organizationUnitId === 'function') ? organizationUnitId() : organizationUnitId)
	const _updatedBy = isRef<string>(updatedBy) ? updatedBy : ref<string>((typeof updatedBy === 'function') ? updatedBy() : updatedBy)
	const _datasetId = isRef<string>(datasetId) ? datasetId : ref<string>((typeof datasetId === 'function') ? datasetId() : datasetId)

	const result = {
		id: _id,
		organizationUnitId: _organizationUnitId,
		updatedBy: _updatedBy,
		datasetId: _datasetId,

		...useCommand(() => {
			if (typeof id === 'function') { _id.value = id() }
			if (typeof organizationUnitId === 'function') { _organizationUnitId.value = organizationUnitId() }
			if (typeof updatedBy === 'function') { _updatedBy.value = updatedBy() }
			if (typeof datasetId === 'function') { _datasetId.value = datasetId() }

			return new c.AttachDatasetCommandV1(_id.value, _organizationUnitId.value, _updatedBy.value, _datasetId.value)
		})
	}

	return {
		...result,
		authorizedAttachDatasetCommandV1: result.authorized,
		attachDatasetCommandV1: result.command,
		completedAttachDatasetCommandV1: result.completed,
		errorAttachDatasetCommandV1: result.error,
		invokeAttachDatasetCommandV1: result.invoke,
		invokingAttachDatasetCommandV1: result.invoking,
		succeedAttachDatasetCommandV1: result.succeed,
		validationErrorsAttachDatasetCommandV1: result.validationErrors,
		onSucceedAttachDatasetCommandV1: result.onSucceed,
	}
}

export function useChangeApplyChangesModeCommandV1(
	id?: string | Ref<string> | (() => string), 
	organizationUnitId?: string | Ref<string> | (() => string), 
	updatedBy?: string | Ref<string> | (() => string), 
	applyChangesMode?: any | Ref<any> | (() => any), 
) 
{
	const _id = isRef<string>(id) ? id : ref<string>((typeof id === 'function') ? id() : id)
	const _organizationUnitId = isRef<string>(organizationUnitId) ? organizationUnitId : ref<string>((typeof organizationUnitId === 'function') ? organizationUnitId() : organizationUnitId)
	const _updatedBy = isRef<string>(updatedBy) ? updatedBy : ref<string>((typeof updatedBy === 'function') ? updatedBy() : updatedBy)
	const _applyChangesMode = isRef<any>(applyChangesMode) ? applyChangesMode : ref<any>((typeof applyChangesMode === 'function') ? applyChangesMode() : applyChangesMode)

	const result = {
		id: _id,
		organizationUnitId: _organizationUnitId,
		updatedBy: _updatedBy,
		applyChangesMode: _applyChangesMode,

		...useCommand(() => {
			if (typeof id === 'function') { _id.value = id() }
			if (typeof organizationUnitId === 'function') { _organizationUnitId.value = organizationUnitId() }
			if (typeof updatedBy === 'function') { _updatedBy.value = updatedBy() }
			if (typeof applyChangesMode === 'function') { _applyChangesMode.value = applyChangesMode() }

			return new c.ChangeApplyChangesModeCommandV1(_id.value, _organizationUnitId.value, _updatedBy.value, _applyChangesMode.value)
		})
	}

	return {
		...result,
		authorizedChangeApplyChangesModeCommandV1: result.authorized,
		changeApplyChangesModeCommandV1: result.command,
		completedChangeApplyChangesModeCommandV1: result.completed,
		errorChangeApplyChangesModeCommandV1: result.error,
		invokeChangeApplyChangesModeCommandV1: result.invoke,
		invokingChangeApplyChangesModeCommandV1: result.invoking,
		succeedChangeApplyChangesModeCommandV1: result.succeed,
		validationErrorsChangeApplyChangesModeCommandV1: result.validationErrors,
		onSucceedChangeApplyChangesModeCommandV1: result.onSucceed,
	}
}

export function useChangeDataStreamCommandV1(
	id?: string | Ref<string> | (() => string), 
	organizationUnitId?: string | Ref<string> | (() => string), 
	updatedBy?: string | Ref<string> | (() => string), 
	dataStream?: string | Ref<string> | (() => string), 
) 
{
	const _id = isRef<string>(id) ? id : ref<string>((typeof id === 'function') ? id() : id)
	const _organizationUnitId = isRef<string>(organizationUnitId) ? organizationUnitId : ref<string>((typeof organizationUnitId === 'function') ? organizationUnitId() : organizationUnitId)
	const _updatedBy = isRef<string>(updatedBy) ? updatedBy : ref<string>((typeof updatedBy === 'function') ? updatedBy() : updatedBy)
	const _dataStream = isRef<string>(dataStream) ? dataStream : ref<string>((typeof dataStream === 'function') ? dataStream() : dataStream)

	const result = {
		id: _id,
		organizationUnitId: _organizationUnitId,
		updatedBy: _updatedBy,
		dataStream: _dataStream,

		...useCommand(() => {
			if (typeof id === 'function') { _id.value = id() }
			if (typeof organizationUnitId === 'function') { _organizationUnitId.value = organizationUnitId() }
			if (typeof updatedBy === 'function') { _updatedBy.value = updatedBy() }
			if (typeof dataStream === 'function') { _dataStream.value = dataStream() }

			return new c.ChangeDataStreamCommandV1(_id.value, _organizationUnitId.value, _updatedBy.value, _dataStream.value)
		})
	}

	return {
		...result,
		authorizedChangeDataStreamCommandV1: result.authorized,
		changeDataStreamCommandV1: result.command,
		completedChangeDataStreamCommandV1: result.completed,
		errorChangeDataStreamCommandV1: result.error,
		invokeChangeDataStreamCommandV1: result.invoke,
		invokingChangeDataStreamCommandV1: result.invoking,
		succeedChangeDataStreamCommandV1: result.succeed,
		validationErrorsChangeDataStreamCommandV1: result.validationErrors,
		onSucceedChangeDataStreamCommandV1: result.onSucceed,
	}
}

export function useChangeIdPropertyNameForConnectorCommandV1(
	id?: string | Ref<string> | (() => string), 
	organizationUnitId?: string | Ref<string> | (() => string), 
	updatedBy?: string | Ref<string> | (() => string), 
	idPropertyName?: string | Ref<string> | (() => string), 
) 
{
	const _id = isRef<string>(id) ? id : ref<string>((typeof id === 'function') ? id() : id)
	const _organizationUnitId = isRef<string>(organizationUnitId) ? organizationUnitId : ref<string>((typeof organizationUnitId === 'function') ? organizationUnitId() : organizationUnitId)
	const _updatedBy = isRef<string>(updatedBy) ? updatedBy : ref<string>((typeof updatedBy === 'function') ? updatedBy() : updatedBy)
	const _idPropertyName = isRef<string>(idPropertyName) ? idPropertyName : ref<string>((typeof idPropertyName === 'function') ? idPropertyName() : idPropertyName)

	const result = {
		id: _id,
		organizationUnitId: _organizationUnitId,
		updatedBy: _updatedBy,
		idPropertyName: _idPropertyName,

		...useCommand(() => {
			if (typeof id === 'function') { _id.value = id() }
			if (typeof organizationUnitId === 'function') { _organizationUnitId.value = organizationUnitId() }
			if (typeof updatedBy === 'function') { _updatedBy.value = updatedBy() }
			if (typeof idPropertyName === 'function') { _idPropertyName.value = idPropertyName() }

			return new c.ChangeIdPropertyNameForConnectorCommandV1(_id.value, _organizationUnitId.value, _updatedBy.value, _idPropertyName.value)
		})
	}

	return {
		...result,
		authorizedChangeIdPropertyNameForConnectorCommandV1: result.authorized,
		changeIdPropertyNameForConnectorCommandV1: result.command,
		completedChangeIdPropertyNameForConnectorCommandV1: result.completed,
		errorChangeIdPropertyNameForConnectorCommandV1: result.error,
		invokeChangeIdPropertyNameForConnectorCommandV1: result.invoke,
		invokingChangeIdPropertyNameForConnectorCommandV1: result.invoking,
		succeedChangeIdPropertyNameForConnectorCommandV1: result.succeed,
		validationErrorsChangeIdPropertyNameForConnectorCommandV1: result.validationErrors,
		onSucceedChangeIdPropertyNameForConnectorCommandV1: result.onSucceed,
	}
}

export function useChangeIdPropertyNameForDatasetCommandV1(
	id?: string | Ref<string> | (() => string), 
	organizationUnitId?: string | Ref<string> | (() => string), 
	updatedBy?: string | Ref<string> | (() => string), 
	idPropertyName?: string | Ref<string> | (() => string), 
) 
{
	const _id = isRef<string>(id) ? id : ref<string>((typeof id === 'function') ? id() : id)
	const _organizationUnitId = isRef<string>(organizationUnitId) ? organizationUnitId : ref<string>((typeof organizationUnitId === 'function') ? organizationUnitId() : organizationUnitId)
	const _updatedBy = isRef<string>(updatedBy) ? updatedBy : ref<string>((typeof updatedBy === 'function') ? updatedBy() : updatedBy)
	const _idPropertyName = isRef<string>(idPropertyName) ? idPropertyName : ref<string>((typeof idPropertyName === 'function') ? idPropertyName() : idPropertyName)

	const result = {
		id: _id,
		organizationUnitId: _organizationUnitId,
		updatedBy: _updatedBy,
		idPropertyName: _idPropertyName,

		...useCommand(() => {
			if (typeof id === 'function') { _id.value = id() }
			if (typeof organizationUnitId === 'function') { _organizationUnitId.value = organizationUnitId() }
			if (typeof updatedBy === 'function') { _updatedBy.value = updatedBy() }
			if (typeof idPropertyName === 'function') { _idPropertyName.value = idPropertyName() }

			return new c.ChangeIdPropertyNameForDatasetCommandV1(_id.value, _organizationUnitId.value, _updatedBy.value, _idPropertyName.value)
		})
	}

	return {
		...result,
		authorizedChangeIdPropertyNameForDatasetCommandV1: result.authorized,
		changeIdPropertyNameForDatasetCommandV1: result.command,
		completedChangeIdPropertyNameForDatasetCommandV1: result.completed,
		errorChangeIdPropertyNameForDatasetCommandV1: result.error,
		invokeChangeIdPropertyNameForDatasetCommandV1: result.invoke,
		invokingChangeIdPropertyNameForDatasetCommandV1: result.invoking,
		succeedChangeIdPropertyNameForDatasetCommandV1: result.succeed,
		validationErrorsChangeIdPropertyNameForDatasetCommandV1: result.validationErrors,
		onSucceedChangeIdPropertyNameForDatasetCommandV1: result.onSucceed,
	}
}

export function useChangeIdPropertyNamesForConnectorCommandV1(
	id?: string | Ref<string> | (() => string), 
	organizationUnitId?: string | Ref<string> | (() => string), 
	updatedBy?: string | Ref<string> | (() => string), 
	idPropertyNames?: any | Ref<any> | (() => any), 
) 
{
	const _id = isRef<string>(id) ? id : ref<string>((typeof id === 'function') ? id() : id)
	const _organizationUnitId = isRef<string>(organizationUnitId) ? organizationUnitId : ref<string>((typeof organizationUnitId === 'function') ? organizationUnitId() : organizationUnitId)
	const _updatedBy = isRef<string>(updatedBy) ? updatedBy : ref<string>((typeof updatedBy === 'function') ? updatedBy() : updatedBy)
	const _idPropertyNames = isRef<any>(idPropertyNames) ? idPropertyNames : ref<any>((typeof idPropertyNames === 'function') ? idPropertyNames() : idPropertyNames)

	const result = {
		id: _id,
		organizationUnitId: _organizationUnitId,
		updatedBy: _updatedBy,
		idPropertyNames: _idPropertyNames,

		...useCommand(() => {
			if (typeof id === 'function') { _id.value = id() }
			if (typeof organizationUnitId === 'function') { _organizationUnitId.value = organizationUnitId() }
			if (typeof updatedBy === 'function') { _updatedBy.value = updatedBy() }
			if (typeof idPropertyNames === 'function') { _idPropertyNames.value = idPropertyNames() }

			return new c.ChangeIdPropertyNamesForConnectorCommandV1(_id.value, _organizationUnitId.value, _updatedBy.value, _idPropertyNames.value)
		})
	}

	return {
		...result,
		authorizedChangeIdPropertyNamesForConnectorCommandV1: result.authorized,
		changeIdPropertyNamesForConnectorCommandV1: result.command,
		completedChangeIdPropertyNamesForConnectorCommandV1: result.completed,
		errorChangeIdPropertyNamesForConnectorCommandV1: result.error,
		invokeChangeIdPropertyNamesForConnectorCommandV1: result.invoke,
		invokingChangeIdPropertyNamesForConnectorCommandV1: result.invoking,
		succeedChangeIdPropertyNamesForConnectorCommandV1: result.succeed,
		validationErrorsChangeIdPropertyNamesForConnectorCommandV1: result.validationErrors,
		onSucceedChangeIdPropertyNamesForConnectorCommandV1: result.onSucceed,
	}
}

export function useChangeIdPropertyNamesForDatasetCommandV1(
	id?: string | Ref<string> | (() => string), 
	organizationUnitId?: string | Ref<string> | (() => string), 
	updatedBy?: string | Ref<string> | (() => string), 
	idPropertyNames?: any | Ref<any> | (() => any), 
) 
{
	const _id = isRef<string>(id) ? id : ref<string>((typeof id === 'function') ? id() : id)
	const _organizationUnitId = isRef<string>(organizationUnitId) ? organizationUnitId : ref<string>((typeof organizationUnitId === 'function') ? organizationUnitId() : organizationUnitId)
	const _updatedBy = isRef<string>(updatedBy) ? updatedBy : ref<string>((typeof updatedBy === 'function') ? updatedBy() : updatedBy)
	const _idPropertyNames = isRef<any>(idPropertyNames) ? idPropertyNames : ref<any>((typeof idPropertyNames === 'function') ? idPropertyNames() : idPropertyNames)

	const result = {
		id: _id,
		organizationUnitId: _organizationUnitId,
		updatedBy: _updatedBy,
		idPropertyNames: _idPropertyNames,

		...useCommand(() => {
			if (typeof id === 'function') { _id.value = id() }
			if (typeof organizationUnitId === 'function') { _organizationUnitId.value = organizationUnitId() }
			if (typeof updatedBy === 'function') { _updatedBy.value = updatedBy() }
			if (typeof idPropertyNames === 'function') { _idPropertyNames.value = idPropertyNames() }

			return new c.ChangeIdPropertyNamesForDatasetCommandV1(_id.value, _organizationUnitId.value, _updatedBy.value, _idPropertyNames.value)
		})
	}

	return {
		...result,
		authorizedChangeIdPropertyNamesForDatasetCommandV1: result.authorized,
		changeIdPropertyNamesForDatasetCommandV1: result.command,
		completedChangeIdPropertyNamesForDatasetCommandV1: result.completed,
		errorChangeIdPropertyNamesForDatasetCommandV1: result.error,
		invokeChangeIdPropertyNamesForDatasetCommandV1: result.invoke,
		invokingChangeIdPropertyNamesForDatasetCommandV1: result.invoking,
		succeedChangeIdPropertyNamesForDatasetCommandV1: result.succeed,
		validationErrorsChangeIdPropertyNamesForDatasetCommandV1: result.validationErrors,
		onSucceedChangeIdPropertyNamesForDatasetCommandV1: result.onSucceed,
	}
}

export function useChangePipelineInternalConnectorTriggerCommandV1(
	id?: string | Ref<string> | (() => string), 
	organizationUnitId?: string | Ref<string> | (() => string), 
	updatedBy?: string | Ref<string> | (() => string), 
	internalConnectorTrigger?: string | Ref<string> | (() => string), 
) 
{
	const _id = isRef<string>(id) ? id : ref<string>((typeof id === 'function') ? id() : id)
	const _organizationUnitId = isRef<string>(organizationUnitId) ? organizationUnitId : ref<string>((typeof organizationUnitId === 'function') ? organizationUnitId() : organizationUnitId)
	const _updatedBy = isRef<string>(updatedBy) ? updatedBy : ref<string>((typeof updatedBy === 'function') ? updatedBy() : updatedBy)
	const _internalConnectorTrigger = isRef<string>(internalConnectorTrigger) ? internalConnectorTrigger : ref<string>((typeof internalConnectorTrigger === 'function') ? internalConnectorTrigger() : internalConnectorTrigger)

	const result = {
		id: _id,
		organizationUnitId: _organizationUnitId,
		updatedBy: _updatedBy,
		internalConnectorTrigger: _internalConnectorTrigger,

		...useCommand(() => {
			if (typeof id === 'function') { _id.value = id() }
			if (typeof organizationUnitId === 'function') { _organizationUnitId.value = organizationUnitId() }
			if (typeof updatedBy === 'function') { _updatedBy.value = updatedBy() }
			if (typeof internalConnectorTrigger === 'function') { _internalConnectorTrigger.value = internalConnectorTrigger() }

			return new c.ChangePipelineInternalConnectorTriggerCommandV1(_id.value, _organizationUnitId.value, _updatedBy.value, _internalConnectorTrigger.value)
		})
	}

	return {
		...result,
		authorizedChangePipelineInternalConnectorTriggerCommandV1: result.authorized,
		changePipelineInternalConnectorTriggerCommandV1: result.command,
		completedChangePipelineInternalConnectorTriggerCommandV1: result.completed,
		errorChangePipelineInternalConnectorTriggerCommandV1: result.error,
		invokeChangePipelineInternalConnectorTriggerCommandV1: result.invoke,
		invokingChangePipelineInternalConnectorTriggerCommandV1: result.invoking,
		succeedChangePipelineInternalConnectorTriggerCommandV1: result.succeed,
		validationErrorsChangePipelineInternalConnectorTriggerCommandV1: result.validationErrors,
		onSucceedChangePipelineInternalConnectorTriggerCommandV1: result.onSucceed,
	}
}

export function useChangePipelineTimeTriggerRecurrencyCommandV1(
	id?: string | Ref<string> | (() => string), 
	organizationUnitId?: string | Ref<string> | (() => string), 
	updatedBy?: string | Ref<string> | (() => string), 
	timeTriggerRecurrency?: any | null | Ref<any | null> | (() => any | null), 
) 
{
	const _id = isRef<string>(id) ? id : ref<string>((typeof id === 'function') ? id() : id)
	const _organizationUnitId = isRef<string>(organizationUnitId) ? organizationUnitId : ref<string>((typeof organizationUnitId === 'function') ? organizationUnitId() : organizationUnitId)
	const _updatedBy = isRef<string>(updatedBy) ? updatedBy : ref<string>((typeof updatedBy === 'function') ? updatedBy() : updatedBy)
	const _timeTriggerRecurrency = isRef<any | null>(timeTriggerRecurrency) ? timeTriggerRecurrency : ref<any | null>((typeof timeTriggerRecurrency === 'function') ? timeTriggerRecurrency() : timeTriggerRecurrency)

	const result = {
		id: _id,
		organizationUnitId: _organizationUnitId,
		updatedBy: _updatedBy,
		timeTriggerRecurrency: _timeTriggerRecurrency,

		...useCommand(() => {
			if (typeof id === 'function') { _id.value = id() }
			if (typeof organizationUnitId === 'function') { _organizationUnitId.value = organizationUnitId() }
			if (typeof updatedBy === 'function') { _updatedBy.value = updatedBy() }
			if (typeof timeTriggerRecurrency === 'function') { _timeTriggerRecurrency.value = timeTriggerRecurrency() }

			return new c.ChangePipelineTimeTriggerRecurrencyCommandV1(_id.value, _organizationUnitId.value, _updatedBy.value, _timeTriggerRecurrency.value)
		})
	}

	return {
		...result,
		authorizedChangePipelineTimeTriggerRecurrencyCommandV1: result.authorized,
		changePipelineTimeTriggerRecurrencyCommandV1: result.command,
		completedChangePipelineTimeTriggerRecurrencyCommandV1: result.completed,
		errorChangePipelineTimeTriggerRecurrencyCommandV1: result.error,
		invokeChangePipelineTimeTriggerRecurrencyCommandV1: result.invoke,
		invokingChangePipelineTimeTriggerRecurrencyCommandV1: result.invoking,
		succeedChangePipelineTimeTriggerRecurrencyCommandV1: result.succeed,
		validationErrorsChangePipelineTimeTriggerRecurrencyCommandV1: result.validationErrors,
		onSucceedChangePipelineTimeTriggerRecurrencyCommandV1: result.onSucceed,
	}
}

export function useChangePipelineTriggerOnRunCompletedCommandV1(
	id?: string | Ref<string> | (() => string), 
	organizationUnitId?: string | Ref<string> | (() => string), 
	updatedBy?: string | Ref<string> | (() => string), 
	triggerOnRunCompleted?: string | null | Ref<string | null> | (() => string | null), 
) 
{
	const _id = isRef<string>(id) ? id : ref<string>((typeof id === 'function') ? id() : id)
	const _organizationUnitId = isRef<string>(organizationUnitId) ? organizationUnitId : ref<string>((typeof organizationUnitId === 'function') ? organizationUnitId() : organizationUnitId)
	const _updatedBy = isRef<string>(updatedBy) ? updatedBy : ref<string>((typeof updatedBy === 'function') ? updatedBy() : updatedBy)
	const _triggerOnRunCompleted = isRef<string | null>(triggerOnRunCompleted) ? triggerOnRunCompleted : ref<string | null>((typeof triggerOnRunCompleted === 'function') ? triggerOnRunCompleted() : triggerOnRunCompleted)

	const result = {
		id: _id,
		organizationUnitId: _organizationUnitId,
		updatedBy: _updatedBy,
		triggerOnRunCompleted: _triggerOnRunCompleted,

		...useCommand(() => {
			if (typeof id === 'function') { _id.value = id() }
			if (typeof organizationUnitId === 'function') { _organizationUnitId.value = organizationUnitId() }
			if (typeof updatedBy === 'function') { _updatedBy.value = updatedBy() }
			if (typeof triggerOnRunCompleted === 'function') { _triggerOnRunCompleted.value = triggerOnRunCompleted() }

			return new c.ChangePipelineTriggerOnRunCompletedCommandV1(_id.value, _organizationUnitId.value, _updatedBy.value, _triggerOnRunCompleted.value)
		})
	}

	return {
		...result,
		authorizedChangePipelineTriggerOnRunCompletedCommandV1: result.authorized,
		changePipelineTriggerOnRunCompletedCommandV1: result.command,
		completedChangePipelineTriggerOnRunCompletedCommandV1: result.completed,
		errorChangePipelineTriggerOnRunCompletedCommandV1: result.error,
		invokeChangePipelineTriggerOnRunCompletedCommandV1: result.invoke,
		invokingChangePipelineTriggerOnRunCompletedCommandV1: result.invoking,
		succeedChangePipelineTriggerOnRunCompletedCommandV1: result.succeed,
		validationErrorsChangePipelineTriggerOnRunCompletedCommandV1: result.validationErrors,
		onSucceedChangePipelineTriggerOnRunCompletedCommandV1: result.onSucceed,
	}
}

export function useCreatePipelineCommandV1(
	id?: string | Ref<string> | (() => string), 
	organizationUnitId?: string | Ref<string> | (() => string), 
	createdBy?: string | Ref<string> | (() => string), 
	name?: string | Ref<string> | (() => string), 
	description?: string | Ref<string> | (() => string), 
	direction?: any | Ref<any> | (() => any), 
	timeTriggerRecurrency?: any | null | Ref<any | null> | (() => any | null), 
) 
{
	const _id = isRef<string>(id) ? id : ref<string>((typeof id === 'function') ? id() : id)
	const _organizationUnitId = isRef<string>(organizationUnitId) ? organizationUnitId : ref<string>((typeof organizationUnitId === 'function') ? organizationUnitId() : organizationUnitId)
	const _createdBy = isRef<string>(createdBy) ? createdBy : ref<string>((typeof createdBy === 'function') ? createdBy() : createdBy)
	const _name = isRef<string>(name) ? name : ref<string>((typeof name === 'function') ? name() : name)
	const _description = isRef<string>(description) ? description : ref<string>((typeof description === 'function') ? description() : description)
	const _direction = isRef<any>(direction) ? direction : ref<any>((typeof direction === 'function') ? direction() : direction)
	const _timeTriggerRecurrency = isRef<any | null>(timeTriggerRecurrency) ? timeTriggerRecurrency : ref<any | null>((typeof timeTriggerRecurrency === 'function') ? timeTriggerRecurrency() : timeTriggerRecurrency)

	const result = {
		id: _id,
		organizationUnitId: _organizationUnitId,
		createdBy: _createdBy,
		name: _name,
		description: _description,
		direction: _direction,
		timeTriggerRecurrency: _timeTriggerRecurrency,

		...useCommand(() => {
			if (typeof id === 'function') { _id.value = id() }
			if (typeof organizationUnitId === 'function') { _organizationUnitId.value = organizationUnitId() }
			if (typeof createdBy === 'function') { _createdBy.value = createdBy() }
			if (typeof name === 'function') { _name.value = name() }
			if (typeof description === 'function') { _description.value = description() }
			if (typeof direction === 'function') { _direction.value = direction() }
			if (typeof timeTriggerRecurrency === 'function') { _timeTriggerRecurrency.value = timeTriggerRecurrency() }

			return new c.CreatePipelineCommandV1(_id.value, _organizationUnitId.value, _createdBy.value, _name.value, _description.value, _direction.value, _timeTriggerRecurrency.value)
		})
	}

	return {
		...result,
		authorizedCreatePipelineCommandV1: result.authorized,
		createPipelineCommandV1: result.command,
		completedCreatePipelineCommandV1: result.completed,
		errorCreatePipelineCommandV1: result.error,
		invokeCreatePipelineCommandV1: result.invoke,
		invokingCreatePipelineCommandV1: result.invoking,
		succeedCreatePipelineCommandV1: result.succeed,
		validationErrorsCreatePipelineCommandV1: result.validationErrors,
		onSucceedCreatePipelineCommandV1: result.onSucceed,
	}
}

export function useDeactivatePipelineCommandV1(
	id?: string | Ref<string> | (() => string), 
	organizationUnitId?: string | Ref<string> | (() => string), 
	updatedBy?: string | Ref<string> | (() => string), 
) 
{
	const _id = isRef<string>(id) ? id : ref<string>((typeof id === 'function') ? id() : id)
	const _organizationUnitId = isRef<string>(organizationUnitId) ? organizationUnitId : ref<string>((typeof organizationUnitId === 'function') ? organizationUnitId() : organizationUnitId)
	const _updatedBy = isRef<string>(updatedBy) ? updatedBy : ref<string>((typeof updatedBy === 'function') ? updatedBy() : updatedBy)

	const result = {
		id: _id,
		organizationUnitId: _organizationUnitId,
		updatedBy: _updatedBy,

		...useCommand(() => {
			if (typeof id === 'function') { _id.value = id() }
			if (typeof organizationUnitId === 'function') { _organizationUnitId.value = organizationUnitId() }
			if (typeof updatedBy === 'function') { _updatedBy.value = updatedBy() }

			return new c.DeactivatePipelineCommandV1(_id.value, _organizationUnitId.value, _updatedBy.value)
		})
	}

	return {
		...result,
		authorizedDeactivatePipelineCommandV1: result.authorized,
		deactivatePipelineCommandV1: result.command,
		completedDeactivatePipelineCommandV1: result.completed,
		errorDeactivatePipelineCommandV1: result.error,
		invokeDeactivatePipelineCommandV1: result.invoke,
		invokingDeactivatePipelineCommandV1: result.invoking,
		succeedDeactivatePipelineCommandV1: result.succeed,
		validationErrorsDeactivatePipelineCommandV1: result.validationErrors,
		onSucceedDeactivatePipelineCommandV1: result.onSucceed,
	}
}

export function useDeletePipelineCommandV1(
	id?: string | Ref<string> | (() => string), 
	organizationUnitId?: string | Ref<string> | (() => string), 
	deletedBy?: string | Ref<string> | (() => string), 
) 
{
	const _id = isRef<string>(id) ? id : ref<string>((typeof id === 'function') ? id() : id)
	const _organizationUnitId = isRef<string>(organizationUnitId) ? organizationUnitId : ref<string>((typeof organizationUnitId === 'function') ? organizationUnitId() : organizationUnitId)
	const _deletedBy = isRef<string>(deletedBy) ? deletedBy : ref<string>((typeof deletedBy === 'function') ? deletedBy() : deletedBy)

	const result = {
		id: _id,
		organizationUnitId: _organizationUnitId,
		deletedBy: _deletedBy,

		...useCommand(() => {
			if (typeof id === 'function') { _id.value = id() }
			if (typeof organizationUnitId === 'function') { _organizationUnitId.value = organizationUnitId() }
			if (typeof deletedBy === 'function') { _deletedBy.value = deletedBy() }

			return new c.DeletePipelineCommandV1(_id.value, _organizationUnitId.value, _deletedBy.value)
		})
	}

	return {
		...result,
		authorizedDeletePipelineCommandV1: result.authorized,
		deletePipelineCommandV1: result.command,
		completedDeletePipelineCommandV1: result.completed,
		errorDeletePipelineCommandV1: result.error,
		invokeDeletePipelineCommandV1: result.invoke,
		invokingDeletePipelineCommandV1: result.invoking,
		succeedDeletePipelineCommandV1: result.succeed,
		validationErrorsDeletePipelineCommandV1: result.validationErrors,
		onSucceedDeletePipelineCommandV1: result.onSucceed,
	}
}

export function useExcludePipelineConnectorPropertyCommandV1(
	id?: string | Ref<string> | (() => string), 
	organizationUnitId?: string | Ref<string> | (() => string), 
	updatedBy?: string | Ref<string> | (() => string), 
	propertyName?: string | Ref<string> | (() => string), 
) 
{
	const _id = isRef<string>(id) ? id : ref<string>((typeof id === 'function') ? id() : id)
	const _organizationUnitId = isRef<string>(organizationUnitId) ? organizationUnitId : ref<string>((typeof organizationUnitId === 'function') ? organizationUnitId() : organizationUnitId)
	const _updatedBy = isRef<string>(updatedBy) ? updatedBy : ref<string>((typeof updatedBy === 'function') ? updatedBy() : updatedBy)
	const _propertyName = isRef<string>(propertyName) ? propertyName : ref<string>((typeof propertyName === 'function') ? propertyName() : propertyName)

	const result = {
		id: _id,
		organizationUnitId: _organizationUnitId,
		updatedBy: _updatedBy,
		propertyName: _propertyName,

		...useCommand(() => {
			if (typeof id === 'function') { _id.value = id() }
			if (typeof organizationUnitId === 'function') { _organizationUnitId.value = organizationUnitId() }
			if (typeof updatedBy === 'function') { _updatedBy.value = updatedBy() }
			if (typeof propertyName === 'function') { _propertyName.value = propertyName() }

			return new c.ExcludePipelineConnectorPropertyCommandV1(_id.value, _organizationUnitId.value, _updatedBy.value, _propertyName.value)
		})
	}

	return {
		...result,
		authorizedExcludePipelineConnectorPropertyCommandV1: result.authorized,
		excludePipelineConnectorPropertyCommandV1: result.command,
		completedExcludePipelineConnectorPropertyCommandV1: result.completed,
		errorExcludePipelineConnectorPropertyCommandV1: result.error,
		invokeExcludePipelineConnectorPropertyCommandV1: result.invoke,
		invokingExcludePipelineConnectorPropertyCommandV1: result.invoking,
		succeedExcludePipelineConnectorPropertyCommandV1: result.succeed,
		validationErrorsExcludePipelineConnectorPropertyCommandV1: result.validationErrors,
		onSucceedExcludePipelineConnectorPropertyCommandV1: result.onSucceed,
	}
}

export function useExcludePipelineDatasetPropertyCommandV1(
	id?: string | Ref<string> | (() => string), 
	organizationUnitId?: string | Ref<string> | (() => string), 
	updatedBy?: string | Ref<string> | (() => string), 
	propertyName?: string | Ref<string> | (() => string), 
) 
{
	const _id = isRef<string>(id) ? id : ref<string>((typeof id === 'function') ? id() : id)
	const _organizationUnitId = isRef<string>(organizationUnitId) ? organizationUnitId : ref<string>((typeof organizationUnitId === 'function') ? organizationUnitId() : organizationUnitId)
	const _updatedBy = isRef<string>(updatedBy) ? updatedBy : ref<string>((typeof updatedBy === 'function') ? updatedBy() : updatedBy)
	const _propertyName = isRef<string>(propertyName) ? propertyName : ref<string>((typeof propertyName === 'function') ? propertyName() : propertyName)

	const result = {
		id: _id,
		organizationUnitId: _organizationUnitId,
		updatedBy: _updatedBy,
		propertyName: _propertyName,

		...useCommand(() => {
			if (typeof id === 'function') { _id.value = id() }
			if (typeof organizationUnitId === 'function') { _organizationUnitId.value = organizationUnitId() }
			if (typeof updatedBy === 'function') { _updatedBy.value = updatedBy() }
			if (typeof propertyName === 'function') { _propertyName.value = propertyName() }

			return new c.ExcludePipelineDatasetPropertyCommandV1(_id.value, _organizationUnitId.value, _updatedBy.value, _propertyName.value)
		})
	}

	return {
		...result,
		authorizedExcludePipelineDatasetPropertyCommandV1: result.authorized,
		excludePipelineDatasetPropertyCommandV1: result.command,
		completedExcludePipelineDatasetPropertyCommandV1: result.completed,
		errorExcludePipelineDatasetPropertyCommandV1: result.error,
		invokeExcludePipelineDatasetPropertyCommandV1: result.invoke,
		invokingExcludePipelineDatasetPropertyCommandV1: result.invoking,
		succeedExcludePipelineDatasetPropertyCommandV1: result.succeed,
		validationErrorsExcludePipelineDatasetPropertyCommandV1: result.validationErrors,
		onSucceedExcludePipelineDatasetPropertyCommandV1: result.onSucceed,
	}
}

export function useExcludePipelinePropertyCommandV1(
	id?: string | Ref<string> | (() => string), 
	organizationUnitId?: string | Ref<string> | (() => string), 
	updatedBy?: string | Ref<string> | (() => string), 
	propertyName?: string | Ref<string> | (() => string), 
) 
{
	const _id = isRef<string>(id) ? id : ref<string>((typeof id === 'function') ? id() : id)
	const _organizationUnitId = isRef<string>(organizationUnitId) ? organizationUnitId : ref<string>((typeof organizationUnitId === 'function') ? organizationUnitId() : organizationUnitId)
	const _updatedBy = isRef<string>(updatedBy) ? updatedBy : ref<string>((typeof updatedBy === 'function') ? updatedBy() : updatedBy)
	const _propertyName = isRef<string>(propertyName) ? propertyName : ref<string>((typeof propertyName === 'function') ? propertyName() : propertyName)

	const result = {
		id: _id,
		organizationUnitId: _organizationUnitId,
		updatedBy: _updatedBy,
		propertyName: _propertyName,

		...useCommand(() => {
			if (typeof id === 'function') { _id.value = id() }
			if (typeof organizationUnitId === 'function') { _organizationUnitId.value = organizationUnitId() }
			if (typeof updatedBy === 'function') { _updatedBy.value = updatedBy() }
			if (typeof propertyName === 'function') { _propertyName.value = propertyName() }

			return new c.ExcludePipelinePropertyCommandV1(_id.value, _organizationUnitId.value, _updatedBy.value, _propertyName.value)
		})
	}

	return {
		...result,
		authorizedExcludePipelinePropertyCommandV1: result.authorized,
		excludePipelinePropertyCommandV1: result.command,
		completedExcludePipelinePropertyCommandV1: result.completed,
		errorExcludePipelinePropertyCommandV1: result.error,
		invokeExcludePipelinePropertyCommandV1: result.invoke,
		invokingExcludePipelinePropertyCommandV1: result.invoking,
		succeedExcludePipelinePropertyCommandV1: result.succeed,
		validationErrorsExcludePipelinePropertyCommandV1: result.validationErrors,
		onSucceedExcludePipelinePropertyCommandV1: result.onSucceed,
	}
}

export function useIncludePipelineConnectorPropertyCommandV1(
	id?: string | Ref<string> | (() => string), 
	organizationUnitId?: string | Ref<string> | (() => string), 
	updatedBy?: string | Ref<string> | (() => string), 
	propertyName?: string | Ref<string> | (() => string), 
) 
{
	const _id = isRef<string>(id) ? id : ref<string>((typeof id === 'function') ? id() : id)
	const _organizationUnitId = isRef<string>(organizationUnitId) ? organizationUnitId : ref<string>((typeof organizationUnitId === 'function') ? organizationUnitId() : organizationUnitId)
	const _updatedBy = isRef<string>(updatedBy) ? updatedBy : ref<string>((typeof updatedBy === 'function') ? updatedBy() : updatedBy)
	const _propertyName = isRef<string>(propertyName) ? propertyName : ref<string>((typeof propertyName === 'function') ? propertyName() : propertyName)

	const result = {
		id: _id,
		organizationUnitId: _organizationUnitId,
		updatedBy: _updatedBy,
		propertyName: _propertyName,

		...useCommand(() => {
			if (typeof id === 'function') { _id.value = id() }
			if (typeof organizationUnitId === 'function') { _organizationUnitId.value = organizationUnitId() }
			if (typeof updatedBy === 'function') { _updatedBy.value = updatedBy() }
			if (typeof propertyName === 'function') { _propertyName.value = propertyName() }

			return new c.IncludePipelineConnectorPropertyCommandV1(_id.value, _organizationUnitId.value, _updatedBy.value, _propertyName.value)
		})
	}

	return {
		...result,
		authorizedIncludePipelineConnectorPropertyCommandV1: result.authorized,
		includePipelineConnectorPropertyCommandV1: result.command,
		completedIncludePipelineConnectorPropertyCommandV1: result.completed,
		errorIncludePipelineConnectorPropertyCommandV1: result.error,
		invokeIncludePipelineConnectorPropertyCommandV1: result.invoke,
		invokingIncludePipelineConnectorPropertyCommandV1: result.invoking,
		succeedIncludePipelineConnectorPropertyCommandV1: result.succeed,
		validationErrorsIncludePipelineConnectorPropertyCommandV1: result.validationErrors,
		onSucceedIncludePipelineConnectorPropertyCommandV1: result.onSucceed,
	}
}

export function useIncludePipelineDatasetPropertyCommandV1(
	id?: string | Ref<string> | (() => string), 
	organizationUnitId?: string | Ref<string> | (() => string), 
	updatedBy?: string | Ref<string> | (() => string), 
	propertyName?: string | Ref<string> | (() => string), 
) 
{
	const _id = isRef<string>(id) ? id : ref<string>((typeof id === 'function') ? id() : id)
	const _organizationUnitId = isRef<string>(organizationUnitId) ? organizationUnitId : ref<string>((typeof organizationUnitId === 'function') ? organizationUnitId() : organizationUnitId)
	const _updatedBy = isRef<string>(updatedBy) ? updatedBy : ref<string>((typeof updatedBy === 'function') ? updatedBy() : updatedBy)
	const _propertyName = isRef<string>(propertyName) ? propertyName : ref<string>((typeof propertyName === 'function') ? propertyName() : propertyName)

	const result = {
		id: _id,
		organizationUnitId: _organizationUnitId,
		updatedBy: _updatedBy,
		propertyName: _propertyName,

		...useCommand(() => {
			if (typeof id === 'function') { _id.value = id() }
			if (typeof organizationUnitId === 'function') { _organizationUnitId.value = organizationUnitId() }
			if (typeof updatedBy === 'function') { _updatedBy.value = updatedBy() }
			if (typeof propertyName === 'function') { _propertyName.value = propertyName() }

			return new c.IncludePipelineDatasetPropertyCommandV1(_id.value, _organizationUnitId.value, _updatedBy.value, _propertyName.value)
		})
	}

	return {
		...result,
		authorizedIncludePipelineDatasetPropertyCommandV1: result.authorized,
		includePipelineDatasetPropertyCommandV1: result.command,
		completedIncludePipelineDatasetPropertyCommandV1: result.completed,
		errorIncludePipelineDatasetPropertyCommandV1: result.error,
		invokeIncludePipelineDatasetPropertyCommandV1: result.invoke,
		invokingIncludePipelineDatasetPropertyCommandV1: result.invoking,
		succeedIncludePipelineDatasetPropertyCommandV1: result.succeed,
		validationErrorsIncludePipelineDatasetPropertyCommandV1: result.validationErrors,
		onSucceedIncludePipelineDatasetPropertyCommandV1: result.onSucceed,
	}
}

export function useIncludePipelinePropertyCommandV1(
	id?: string | Ref<string> | (() => string), 
	organizationUnitId?: string | Ref<string> | (() => string), 
	updatedBy?: string | Ref<string> | (() => string), 
	propertyName?: string | Ref<string> | (() => string), 
) 
{
	const _id = isRef<string>(id) ? id : ref<string>((typeof id === 'function') ? id() : id)
	const _organizationUnitId = isRef<string>(organizationUnitId) ? organizationUnitId : ref<string>((typeof organizationUnitId === 'function') ? organizationUnitId() : organizationUnitId)
	const _updatedBy = isRef<string>(updatedBy) ? updatedBy : ref<string>((typeof updatedBy === 'function') ? updatedBy() : updatedBy)
	const _propertyName = isRef<string>(propertyName) ? propertyName : ref<string>((typeof propertyName === 'function') ? propertyName() : propertyName)

	const result = {
		id: _id,
		organizationUnitId: _organizationUnitId,
		updatedBy: _updatedBy,
		propertyName: _propertyName,

		...useCommand(() => {
			if (typeof id === 'function') { _id.value = id() }
			if (typeof organizationUnitId === 'function') { _organizationUnitId.value = organizationUnitId() }
			if (typeof updatedBy === 'function') { _updatedBy.value = updatedBy() }
			if (typeof propertyName === 'function') { _propertyName.value = propertyName() }

			return new c.IncludePipelinePropertyCommandV1(_id.value, _organizationUnitId.value, _updatedBy.value, _propertyName.value)
		})
	}

	return {
		...result,
		authorizedIncludePipelinePropertyCommandV1: result.authorized,
		includePipelinePropertyCommandV1: result.command,
		completedIncludePipelinePropertyCommandV1: result.completed,
		errorIncludePipelinePropertyCommandV1: result.error,
		invokeIncludePipelinePropertyCommandV1: result.invoke,
		invokingIncludePipelinePropertyCommandV1: result.invoking,
		succeedIncludePipelinePropertyCommandV1: result.succeed,
		validationErrorsIncludePipelinePropertyCommandV1: result.validationErrors,
		onSucceedIncludePipelinePropertyCommandV1: result.onSucceed,
	}
}

export function useInternalConnectorTriggerCommandV1(
	id?: string | Ref<string> | (() => string), 
	organizationUnitId?: string | Ref<string> | (() => string), 
	triggeredBy?: string | Ref<string> | (() => string), 
	triggerName?: string | Ref<string> | (() => string), 
	triggerData?: string | Ref<string> | (() => string), 
) 
{
	const _id = isRef<string>(id) ? id : ref<string>((typeof id === 'function') ? id() : id)
	const _organizationUnitId = isRef<string>(organizationUnitId) ? organizationUnitId : ref<string>((typeof organizationUnitId === 'function') ? organizationUnitId() : organizationUnitId)
	const _triggeredBy = isRef<string>(triggeredBy) ? triggeredBy : ref<string>((typeof triggeredBy === 'function') ? triggeredBy() : triggeredBy)
	const _triggerName = isRef<string>(triggerName) ? triggerName : ref<string>((typeof triggerName === 'function') ? triggerName() : triggerName)
	const _triggerData = isRef<string>(triggerData) ? triggerData : ref<string>((typeof triggerData === 'function') ? triggerData() : triggerData)

	const result = {
		id: _id,
		organizationUnitId: _organizationUnitId,
		triggeredBy: _triggeredBy,
		triggerName: _triggerName,
		triggerData: _triggerData,

		...useCommand(() => {
			if (typeof id === 'function') { _id.value = id() }
			if (typeof organizationUnitId === 'function') { _organizationUnitId.value = organizationUnitId() }
			if (typeof triggeredBy === 'function') { _triggeredBy.value = triggeredBy() }
			if (typeof triggerName === 'function') { _triggerName.value = triggerName() }
			if (typeof triggerData === 'function') { _triggerData.value = triggerData() }

			return new c.InternalConnectorTriggerCommandV1(_id.value, _organizationUnitId.value, _triggeredBy.value, _triggerName.value, _triggerData.value)
		})
	}

	return {
		...result,
		authorizedInternalConnectorTriggerCommandV1: result.authorized,
		internalConnectorTriggerCommandV1: result.command,
		completedInternalConnectorTriggerCommandV1: result.completed,
		errorInternalConnectorTriggerCommandV1: result.error,
		invokeInternalConnectorTriggerCommandV1: result.invoke,
		invokingInternalConnectorTriggerCommandV1: result.invoking,
		succeedInternalConnectorTriggerCommandV1: result.succeed,
		validationErrorsInternalConnectorTriggerCommandV1: result.validationErrors,
		onSucceedInternalConnectorTriggerCommandV1: result.onSucceed,
	}
}

export function usePermanentDeletePipelineCommandV1(
	id?: string | Ref<string> | (() => string), 
) 
{
	const _id = isRef<string>(id) ? id : ref<string>((typeof id === 'function') ? id() : id)

	const result = {
		id: _id,

		...useCommand(() => {
			if (typeof id === 'function') { _id.value = id() }

			return new c.PermanentDeletePipelineCommandV1(_id.value)
		})
	}

	return {
		...result,
		authorizedPermanentDeletePipelineCommandV1: result.authorized,
		permanentDeletePipelineCommandV1: result.command,
		completedPermanentDeletePipelineCommandV1: result.completed,
		errorPermanentDeletePipelineCommandV1: result.error,
		invokePermanentDeletePipelineCommandV1: result.invoke,
		invokingPermanentDeletePipelineCommandV1: result.invoking,
		succeedPermanentDeletePipelineCommandV1: result.succeed,
		validationErrorsPermanentDeletePipelineCommandV1: result.validationErrors,
		onSucceedPermanentDeletePipelineCommandV1: result.onSucceed,
	}
}

export function useRemovePropertyNameMappingCommandV1(
	id?: string | Ref<string> | (() => string), 
	organizationUnitId?: string | Ref<string> | (() => string), 
	updatedBy?: string | Ref<string> | (() => string), 
	nameForConnector?: string | Ref<string> | (() => string), 
	nameForDataset?: string | Ref<string> | (() => string), 
) 
{
	const _id = isRef<string>(id) ? id : ref<string>((typeof id === 'function') ? id() : id)
	const _organizationUnitId = isRef<string>(organizationUnitId) ? organizationUnitId : ref<string>((typeof organizationUnitId === 'function') ? organizationUnitId() : organizationUnitId)
	const _updatedBy = isRef<string>(updatedBy) ? updatedBy : ref<string>((typeof updatedBy === 'function') ? updatedBy() : updatedBy)
	const _nameForConnector = isRef<string>(nameForConnector) ? nameForConnector : ref<string>((typeof nameForConnector === 'function') ? nameForConnector() : nameForConnector)
	const _nameForDataset = isRef<string>(nameForDataset) ? nameForDataset : ref<string>((typeof nameForDataset === 'function') ? nameForDataset() : nameForDataset)

	const result = {
		id: _id,
		organizationUnitId: _organizationUnitId,
		updatedBy: _updatedBy,
		nameForConnector: _nameForConnector,
		nameForDataset: _nameForDataset,

		...useCommand(() => {
			if (typeof id === 'function') { _id.value = id() }
			if (typeof organizationUnitId === 'function') { _organizationUnitId.value = organizationUnitId() }
			if (typeof updatedBy === 'function') { _updatedBy.value = updatedBy() }
			if (typeof nameForConnector === 'function') { _nameForConnector.value = nameForConnector() }
			if (typeof nameForDataset === 'function') { _nameForDataset.value = nameForDataset() }

			return new c.RemovePropertyNameMappingCommandV1(_id.value, _organizationUnitId.value, _updatedBy.value, _nameForConnector.value, _nameForDataset.value)
		})
	}

	return {
		...result,
		authorizedRemovePropertyNameMappingCommandV1: result.authorized,
		removePropertyNameMappingCommandV1: result.command,
		completedRemovePropertyNameMappingCommandV1: result.completed,
		errorRemovePropertyNameMappingCommandV1: result.error,
		invokeRemovePropertyNameMappingCommandV1: result.invoke,
		invokingRemovePropertyNameMappingCommandV1: result.invoking,
		succeedRemovePropertyNameMappingCommandV1: result.succeed,
		validationErrorsRemovePropertyNameMappingCommandV1: result.validationErrors,
		onSucceedRemovePropertyNameMappingCommandV1: result.onSucceed,
	}
}

export function useResetPipelineRunsCommandV1(
	id?: string | Ref<string> | (() => string), 
	organizationUnitId?: string | Ref<string> | (() => string), 
	updatedBy?: string | Ref<string> | (() => string), 
) 
{
	const _id = isRef<string>(id) ? id : ref<string>((typeof id === 'function') ? id() : id)
	const _organizationUnitId = isRef<string>(organizationUnitId) ? organizationUnitId : ref<string>((typeof organizationUnitId === 'function') ? organizationUnitId() : organizationUnitId)
	const _updatedBy = isRef<string>(updatedBy) ? updatedBy : ref<string>((typeof updatedBy === 'function') ? updatedBy() : updatedBy)

	const result = {
		id: _id,
		organizationUnitId: _organizationUnitId,
		updatedBy: _updatedBy,

		...useCommand(() => {
			if (typeof id === 'function') { _id.value = id() }
			if (typeof organizationUnitId === 'function') { _organizationUnitId.value = organizationUnitId() }
			if (typeof updatedBy === 'function') { _updatedBy.value = updatedBy() }

			return new c.ResetPipelineRunsCommandV1(_id.value, _organizationUnitId.value, _updatedBy.value)
		})
	}

	return {
		...result,
		authorizedResetPipelineRunsCommandV1: result.authorized,
		resetPipelineRunsCommandV1: result.command,
		completedResetPipelineRunsCommandV1: result.completed,
		errorResetPipelineRunsCommandV1: result.error,
		invokeResetPipelineRunsCommandV1: result.invoke,
		invokingResetPipelineRunsCommandV1: result.invoking,
		succeedResetPipelineRunsCommandV1: result.succeed,
		validationErrorsResetPipelineRunsCommandV1: result.validationErrors,
		onSucceedResetPipelineRunsCommandV1: result.onSucceed,
	}
}

export function useSetPipelineLogLevelCommandV1(
	id?: string | Ref<string> | (() => string), 
	organizationUnitId?: string | Ref<string> | (() => string), 
	updatedBy?: string | Ref<string> | (() => string), 
	logLevel?: any | Ref<any> | (() => any), 
) 
{
	const _id = isRef<string>(id) ? id : ref<string>((typeof id === 'function') ? id() : id)
	const _organizationUnitId = isRef<string>(organizationUnitId) ? organizationUnitId : ref<string>((typeof organizationUnitId === 'function') ? organizationUnitId() : organizationUnitId)
	const _updatedBy = isRef<string>(updatedBy) ? updatedBy : ref<string>((typeof updatedBy === 'function') ? updatedBy() : updatedBy)
	const _logLevel = isRef<any>(logLevel) ? logLevel : ref<any>((typeof logLevel === 'function') ? logLevel() : logLevel)

	const result = {
		id: _id,
		organizationUnitId: _organizationUnitId,
		updatedBy: _updatedBy,
		logLevel: _logLevel,

		...useCommand(() => {
			if (typeof id === 'function') { _id.value = id() }
			if (typeof organizationUnitId === 'function') { _organizationUnitId.value = organizationUnitId() }
			if (typeof updatedBy === 'function') { _updatedBy.value = updatedBy() }
			if (typeof logLevel === 'function') { _logLevel.value = logLevel() }

			return new c.SetPipelineLogLevelCommandV1(_id.value, _organizationUnitId.value, _updatedBy.value, _logLevel.value)
		})
	}

	return {
		...result,
		authorizedSetPipelineLogLevelCommandV1: result.authorized,
		setPipelineLogLevelCommandV1: result.command,
		completedSetPipelineLogLevelCommandV1: result.completed,
		errorSetPipelineLogLevelCommandV1: result.error,
		invokeSetPipelineLogLevelCommandV1: result.invoke,
		invokingSetPipelineLogLevelCommandV1: result.invoking,
		succeedSetPipelineLogLevelCommandV1: result.succeed,
		validationErrorsSetPipelineLogLevelCommandV1: result.validationErrors,
		onSucceedSetPipelineLogLevelCommandV1: result.onSucceed,
	}
}

export function useTimeTriggerPipelineCommandV1(
	id?: string | Ref<string> | (() => string), 
	organizationUnitId?: string | Ref<string> | (() => string), 
	triggeredBy?: string | Ref<string> | (() => string), 
) 
{
	const _id = isRef<string>(id) ? id : ref<string>((typeof id === 'function') ? id() : id)
	const _organizationUnitId = isRef<string>(organizationUnitId) ? organizationUnitId : ref<string>((typeof organizationUnitId === 'function') ? organizationUnitId() : organizationUnitId)
	const _triggeredBy = isRef<string>(triggeredBy) ? triggeredBy : ref<string>((typeof triggeredBy === 'function') ? triggeredBy() : triggeredBy)

	const result = {
		id: _id,
		organizationUnitId: _organizationUnitId,
		triggeredBy: _triggeredBy,

		...useCommand(() => {
			if (typeof id === 'function') { _id.value = id() }
			if (typeof organizationUnitId === 'function') { _organizationUnitId.value = organizationUnitId() }
			if (typeof triggeredBy === 'function') { _triggeredBy.value = triggeredBy() }

			return new c.TimeTriggerPipelineCommandV1(_id.value, _organizationUnitId.value, _triggeredBy.value)
		})
	}

	return {
		...result,
		authorizedTimeTriggerPipelineCommandV1: result.authorized,
		timeTriggerPipelineCommandV1: result.command,
		completedTimeTriggerPipelineCommandV1: result.completed,
		errorTimeTriggerPipelineCommandV1: result.error,
		invokeTimeTriggerPipelineCommandV1: result.invoke,
		invokingTimeTriggerPipelineCommandV1: result.invoking,
		succeedTimeTriggerPipelineCommandV1: result.succeed,
		validationErrorsTimeTriggerPipelineCommandV1: result.validationErrors,
		onSucceedTimeTriggerPipelineCommandV1: result.onSucceed,
	}
}

export function useTriggerPipelineManuallyCommandV1(
	id?: string | Ref<string> | (() => string), 
	organizationUnitId?: string | Ref<string> | (() => string), 
	triggeredBy?: string | Ref<string> | (() => string), 
) 
{
	const _id = isRef<string>(id) ? id : ref<string>((typeof id === 'function') ? id() : id)
	const _organizationUnitId = isRef<string>(organizationUnitId) ? organizationUnitId : ref<string>((typeof organizationUnitId === 'function') ? organizationUnitId() : organizationUnitId)
	const _triggeredBy = isRef<string>(triggeredBy) ? triggeredBy : ref<string>((typeof triggeredBy === 'function') ? triggeredBy() : triggeredBy)

	const result = {
		id: _id,
		organizationUnitId: _organizationUnitId,
		triggeredBy: _triggeredBy,

		...useCommand(() => {
			if (typeof id === 'function') { _id.value = id() }
			if (typeof organizationUnitId === 'function') { _organizationUnitId.value = organizationUnitId() }
			if (typeof triggeredBy === 'function') { _triggeredBy.value = triggeredBy() }

			return new c.TriggerPipelineManuallyCommandV1(_id.value, _organizationUnitId.value, _triggeredBy.value)
		})
	}

	return {
		...result,
		authorizedTriggerPipelineManuallyCommandV1: result.authorized,
		triggerPipelineManuallyCommandV1: result.command,
		completedTriggerPipelineManuallyCommandV1: result.completed,
		errorTriggerPipelineManuallyCommandV1: result.error,
		invokeTriggerPipelineManuallyCommandV1: result.invoke,
		invokingTriggerPipelineManuallyCommandV1: result.invoking,
		succeedTriggerPipelineManuallyCommandV1: result.succeed,
		validationErrorsTriggerPipelineManuallyCommandV1: result.validationErrors,
		onSucceedTriggerPipelineManuallyCommandV1: result.onSucceed,
	}
}

export function useTriggerPipelineQueuedRunsCommandV1(
	id?: string | Ref<string> | (() => string), 
) 
{
	const _id = isRef<string>(id) ? id : ref<string>((typeof id === 'function') ? id() : id)

	const result = {
		id: _id,

		...useCommand(() => {
			if (typeof id === 'function') { _id.value = id() }

			return new c.TriggerPipelineQueuedRunsCommandV1(_id.value)
		})
	}

	return {
		...result,
		authorizedTriggerPipelineQueuedRunsCommandV1: result.authorized,
		triggerPipelineQueuedRunsCommandV1: result.command,
		completedTriggerPipelineQueuedRunsCommandV1: result.completed,
		errorTriggerPipelineQueuedRunsCommandV1: result.error,
		invokeTriggerPipelineQueuedRunsCommandV1: result.invoke,
		invokingTriggerPipelineQueuedRunsCommandV1: result.invoking,
		succeedTriggerPipelineQueuedRunsCommandV1: result.succeed,
		validationErrorsTriggerPipelineQueuedRunsCommandV1: result.validationErrors,
		onSucceedTriggerPipelineQueuedRunsCommandV1: result.onSucceed,
	}
}

